import React, {useEffect, useState, useRef} from "../../_snowpack/pkg/react.js";
import {Toaster, toast} from "../../_snowpack/pkg/react-hot-toast.js";
import {Title, Card, DrawnCard} from "../components/Deck/index.js";
import {NewCardButton, NewDeckButton} from "../components/Buttons/index.js";
import DataService from "../utils/DataService.js";
import GlobalStyles from "../components/GlobalStyles.js";
import {
  DeckContainer,
  DeckInfo,
  DeckState,
  CurrentCardContainer,
  PrevCardsContainer,
  DeckActions
} from "../components/Deck/styles.js";
const CandyGame = () => {
  const [deckID, setDeckID] = useState("");
  const [remainingCards, setRemainingCards] = useState(0);
  const [currentCard, setCurrentCard] = useState({
    suit: "N/A",
    value: "N/A",
    image: "N/A",
    code: "N/A"
  });
  const drawnCards = useRef([]);
  const drawNewCard = (payload) => {
    if (remainingCards <= 0) {
      toast.error("No more cards.");
      return;
    }
    const {
      cards: [card],
      remaining
    } = payload;
    if (remainingCards <= 51)
      drawnCards.current.unshift(currentCard);
    setCurrentCard(card);
    setRemainingCards(parseInt(remaining));
  };
  const drawNewDeck = (payload) => {
    if (remainingCards <= 51 || drawnCards.current.length >= 1) {
      const resetDeck = window.confirm("Are you sure you want to get a new deck? Your current deck progress will be lost.");
      if (!resetDeck)
        return;
    }
    const {deck_id: newDeckId, remaining, success} = payload;
    if (!newDeckId || success === false) {
      toast.error("Sorry I dropped the cards! Please try again.");
      return;
    }
    drawnCards.current = [];
    setDeckID(newDeckId);
    setRemainingCards(remaining);
    setCurrentCard({suit: "N/A", value: "N/A", image: "N/A", code: "N/A"});
  };
  useEffect(() => {
    (async () => {
      const newDeck = await DataService.getNewDeck();
      setDeckID(newDeck.deck_id);
      setRemainingCards(newDeck.remaining);
    })().catch((err) => console.log(err));
  }, []);
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(GlobalStyles, null), /* @__PURE__ */ React.createElement(DeckContainer, null, /* @__PURE__ */ React.createElement(Toaster, {
    position: "top-center",
    reverseOrder: false
  }), /* @__PURE__ */ React.createElement(DeckInfo, null, /* @__PURE__ */ React.createElement(Title, {
    title: "52 Card Deck",
    subTitle: "Get a new deck of cards, and pull from the deck one card at a time."
  }), /* @__PURE__ */ React.createElement(DeckActions, null, /* @__PURE__ */ React.createElement(NewDeckButton, {
    text: "New Deck",
    getDeck: () => DataService.getNewDeck(),
    setDeck: drawNewDeck
  }), /* @__PURE__ */ React.createElement(NewCardButton, {
    text: "New Card",
    getCard: () => DataService.getNewCard(deckID),
    setCard: drawNewCard
  }))), /* @__PURE__ */ React.createElement(DeckState, null, /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("p", null, "Cards Remaining: ", remainingCards))), /* @__PURE__ */ React.createElement(CurrentCardContainer, null, currentCard.suit !== "N/A" ? /* @__PURE__ */ React.createElement(Card, {
    suit: currentCard.suit,
    value: currentCard.value,
    image: currentCard.image
  }) : null), /* @__PURE__ */ React.createElement(PrevCardsContainer, null, /* @__PURE__ */ React.createElement("thead", null, /* @__PURE__ */ React.createElement("tr", null, /* @__PURE__ */ React.createElement("td", null, "Previously Drawn Cards"))), /* @__PURE__ */ React.createElement("tbody", null, drawnCards.current.length > 0 ? drawnCards.current.map((card, index) => {
    const {suit, value} = card;
    return /* @__PURE__ */ React.createElement(DrawnCard, {
      key: `${value}_${suit}_${index}`,
      value,
      suit
    });
  }) : null))));
};
export default CandyGame;
